/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type ConfigureAdminRolesModal_UserFragment = { __typename: 'User', id: string, givenName: string, familyName: string, email: string, roles: Array<Types.Role>, serviceAdminRoles: Array<Types.ServiceAdminRole>, customerIds?: Array<string> | null };

export const ConfigureAdminRolesModal_UserFragmentDoc = gql`
    fragment ConfigureAdminRolesModal_user on User {
  id
  givenName
  familyName
  email
  roles
  serviceAdminRoles
  customerIds
}
    `;